import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ActivityLogEntity } from '../../domain/entities/ActivityLogEntity'
import type { AuditEntryAdminDto } from '@/backend/market'

export class ActivityLogModel extends ActivityLogEntity {
  constructor(dataDto: AuditEntryAdminDto) {
    super()
    mapEntityProperties<ActivityLogEntity>(this, dataDto)
  }
}
